var map = {
	"./BarChart.vue": "3fdc",
	"./BaseAccordion.vue": "2a61",
	"./BaseButton.vue": "82ea",
	"./BaseCard.vue": "ff7d",
	"./BaseModal.vue": "c1ec",
	"./BaseNavDropdown.vue": "ce0a",
	"./BaseNavItem.vue": "3b1b5",
	"./BaseProgress.vue": "134b",
	"./BaseTabs.vue": "3315",
	"./BaseTitle.vue": "38fa",
	"./BaseToast.vue": "1b70",
	"./Charts/BarChart.vue": "34c7",
	"./Charts/DistributionBarChart.vue": "ab7e",
	"./Charts/PartnersBarChart.vue": "9a16",
	"./Charts/PensumChart.vue": "e448",
	"./Charts/SalaryIncomeBarChart.vue": "abab",
	"./Charts/SalaryIncomeChart.vue": "59e3",
	"./ClippyNotifications.vue": "c20b",
	"./ClippyToast.vue": "55fe",
	"./HeaderFavoritesTable.vue": "85da",
	"./HomeMessage.vue": "33ae",
	"./Hour.vue": "5d74",
	"./InitialQuestion.vue": "7cd64",
	"./Loading.vue": "3a5e",
	"./LoginDialogs/LetsBegin.vue": "fe7c",
	"./LoginDialogs/LoginDialogContainer.vue": "ee53",
	"./LoginDialogs/ShowVideo.vue": "8888",
	"./LoginDialogs/StudentRegister.vue": "5948",
	"./LoginDialogs/TellUsAboutYourself.vue": "3636",
	"./LoginDialogs/VerifyStudentData.vue": "1881",
	"./LoginFlow/BaseLogin.vue": "646b",
	"./LoginFlow/BaseRegistration.vue": "cd4d",
	"./MainMenu.vue": "add6",
	"./Notifications.vue": "e985",
	"./PensumHours.vue": "2592",
	"./PillKind.vue": "08c5",
	"./ScoreSlider.vue": "91ce",
	"./StarButton.vue": "1387",
	"./ToolbarButton.vue": "7905"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d78d";